import { render } from "./Footer.vue?vue&type=template&id=d40a04a4&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=d40a04a4&lang=scss&scoped=true"

import exportComponent from "../../.yarn/__virtual__/vue-loader-virtual-906ec7a3d2/0/cache/vue-loader-npm-17.4.2-00674d01e5-2b5a15858e.zip/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d40a04a4"]])

export default __exports__